import { useContext } from "react";
import { APIContext } from "../apiContext";

export const useGetTeamDetails = () => {

    const { apiRes } = useContext(APIContext)


    return apiRes;
}